/**
 * Company-email-only: block consumer/personal domains (no Gmail, Yahoo, etc.).
 * Used for sign-up and email sign-in validation.
 */

const BLOCKED_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.za',
  'outlook.com',
  'hotmail.com',
  'hotmail.co.za',
  'live.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'mail.com',
  'protonmail.com',
  'proton.me',
  'zoho.com',
  'yandex.com',
  'gmx.com',
  'gmx.net',
  'web.de',
  'tutanota.com',
  'fastmail.com',
  'mail.ru',
  'inbox.com',
  'msn.com',
  'sky.com',
  'btinternet.com',
  'virginmedia.com',
  'comcast.net',
  'att.net',
  'sbcglobal.net',
  'verizon.net',
  'ymail.com',
  'rocketmail.com',
  'qq.com',
  '163.com',
  '126.com',
]);

/** Normalise email: lowercase, trim; extract domain. */
function getDomain(email: string): string | null {
  const e = email?.trim().toLowerCase();
  if (!e || !e.includes('@')) return null;
  const parts = e.split('@');
  return parts.length === 2 ? parts[1] : null;
}

/** Returns true if the email's domain is a blocked (personal) domain. */
export function isBlockedEmailDomain(email: string): boolean {
  const domain = getDomain(email);
  return domain ? BLOCKED_DOMAINS.has(domain) : true;
}

/** Message shown when user enters a blocked (e.g. Gmail) address. */
export const BLOCKED_EMAIL_MESSAGE =
  'Please use your company or institution email address. Personal email addresses (e.g. Gmail, Yahoo, Outlook) are not allowed.';
